export enum FeatureFlags {
  DUAL_VIEW = "dual-view-feature",
  BEFORE_AFTER = "before-after-feature",
  ENHANCE_CONTRAST = "enhance-contrast-feature",
  INFRARED = "infrared-feature",
  EXPORT_GEOTIFF = "export-geotiff-feature",
  PROPERTIES = "properties-feature",
  DAMAGES = "damages-feature",
  MEASURES = "measures-feature",
  MEASURES_3D = "measures-3d-feature",
  PRIVATE_LAYERS = "private-layers-feature",
  COLLECTION_FILTER = "collection-filter-feature",
  IMAGE_GALLERY = "image-gallery-feature",
  ENHANCED_GEO_SEARCH = "enhanced-geo-search-feature",
  EMBEDDING_GALLERY = "embedding-image-gallery-feature",
  ENHANCED_SEARCH_FILTERS = "enhanced-search-filters-feature",
  CURATOR_CHATBOT = "curator-chatbot-feature",
  IMAGE_SEARCH_UPLOAD = "image-search-upload-feature",
  MAP_CLICK_SEARCH = "map-click-search-feature",
  EXPORT_SEARCH_RESULTS = "export-search-results-feature",
  AI_AGENTS = "ai-agents-feature",
  CUSTOM_ELEMENTS_DETECTION = "custom-elements-detection-feature",
}
